import $ from 'jquery';

export default class ARS_Slider {
    constructor() {
        const config = {
            arrows: true,
            swipeToSlide: true,
            slidesToShow: 5,
            lazyLoad: 'progressive',
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 1080,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 920,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]
        };
        $('.a-s__slider').each((i, e) => {
            const $e = $(e);
            let imgs = $e.find('img').length;
            if (+$e.attr('data-off') !== 1) {
                $e.slick(config).on('lazyLoaded', (event, slick, image, imageSource) => {
                    if (--imgs === 0) {
                        this.clear($e);
                        this.calc($e);
                        reInit();
                    }
                });
            }
            const reInit = () => {
                if (+$e.attr('data-off') === 1) return;
                if ($e.hasClass('slick-initialized')) {
                    $e.slick('destroy');
                    $e.slick(config);
                }
            };
            this.calc($e);
            let resizing = false;
            $(window).on('resize', () => {
                this.clear($e);
                if (resizing) clearTimeout(resizing);
                resizing = setTimeout(() => {
                    this.calc($e);
                    reInit();
                }, 100);
            });
            $(window).trigger('resize');
        });
    }

    calc($e) {
        let h = 0;
        let initH = $e.find('.a-s__artist-image').height();
        $e.find('img').each((ii, ee) => {
            const $ee = $(ee);
            if ($ee.height() > h) h = $ee.height();
            // $ee.css('max-height', '100%');
        });
        const offset = Math.abs(h - initH);
        $e.find('.slick-arrow').css('top', initH / 2 + offset + 'px');
        $e.find('.a-s__artist-image').css('height', h + 'px');
        // $e.css('margin-top', offset * -1 + 'px');
        $e.prev('.a-s__bg').css('top', offset + 'px').css('height', 'calc(100% - ' + offset + 'px)');
        $e.parent('.a-s__artists').css('background-position-y', offset + 'px');
    }
    clear($e) {
        $e.removeAttr('style');
        $e.find('img').removeAttr('style');
        $e.find('.a-s__artist-image').removeAttr('style');
    }
}